import React from "react";
import TermsContent from "../components/terms/TermsContent";
import Newnabar from "../components/shared/Newnabar";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";

import SEO from "../components/shared/SEO";

export default function TermsLayout() {
  return (
    <div>
      <SEO
        title="Terms and Conditions | SoloConnect"
        description="Review the terms and conditions for using the SoloConnect platform and services."
        keywords="terms and conditions, user agreement, terms of service, platform rules"
      />
      <Newnabar />

      <div className="min-h-screen bg-white text-gray-800 px-4 md:px-20 py-10 pt-20 ">
        <h1 className="text-3xl md:text-4xl font-bold text-purple-700 mb-6">
          Terms & Conditions
        </h1>
        <TermsContent />
      </div>
      <div className="hidden md:block" >
        <SoloConnectFooter />
      </div>

      <div className="block md:hidden" >
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
